import React, { useState } from "react";
import styled from "styled-components";

const ImageWrap = styled.div`
  cursor: zoom-in;
  overflow: hidden;
  border-radius: 4px;
  
  img {
    width: 100%;
    height: auto;
    display: block;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    transform: translateZ(0);
    transition: transform 0.3s ease;
  }

  &:hover img {
    transform: scale(1.02) translateZ(0);
  }
`;

const LightboxOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  cursor: zoom-out;
  padding: 40px;
  box-sizing: border-box;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    border-radius: 4px;
    box-shadow: 0 20px 50px rgba(0,0,0,0.5);
  }

  video {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 40px;
  right: 40px;
  background: var(--panel-bg);
  border: 1px solid rgba(150, 150, 150, 0.2);
  color: var(--text-color);
  padding: 10px 20px;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 700;
  cursor: pointer;
  z-index: 1001;
  text-transform: uppercase;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  gap: 10px;

  &:hover {
    background: var(--accent);
    color: #fff;
  }

  @media (max-width: 768px) {
    top: 20px;
    right: 20px;
  }
`;

const PopImage = ({ src, alt, className, isVideo, title }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <ImageWrap className={className} onClick={() => setIsOpen(true)}>
        {isVideo ? (
          <video src={src} autoPlay loop muted playsInline />
        ) : (
          <img src={src} alt={alt || "Case study image"} />
        )}
      </ImageWrap>

      {isOpen && (
        <LightboxOverlay onClick={() => setIsOpen(false)}>
          <CloseButton onClick={(e) => { e.stopPropagation(); setIsOpen(false); }}>
            Back to {title || "Case Study"}
          </CloseButton>
          {isVideo ? (
             <video src={src} autoPlay loop muted playsInline controls={false} />
          ) : (
             <img src={src} alt={alt || "Case study popup"} />
          )}
        </LightboxOverlay>
      )}
    </>
  );
};

export default PopImage;
